import { createFileRoute } from "@tanstack/react-router";
import { GuideHomePage } from "@/features/guide";

export const Route = createFileRoute("/guide/")({
  component: GuideHomePage,
});
